import Util from "@/helper/Utility.js";

export default {
    inject: ["AccountStore"],
    computed: {
        isInitial: function () {
            return this.AccountStore.state.isInitial;
        },
        isLogin: function () {
            return this.AccountStore.state.isLogin;
        },
        profile: function () {
            if (this.isLogin) {
                return this.AccountStore.state.profile;
            } else {
                return null;
            }
        },
        userPoint: function () {
            if (this.isLogin) {
                return this.AccountStore.state.point;
            } else {
                return 0;
            }
        },
    },
    created: function () {
        this.AccountStore.methods.loginStatus().subscribe(() => {
            if (Util.isFunction(this.onAccountInit)) {
                this.onAccountInit();
            }
        });
    },
    methods: {
        setUpdatePoint: function (point) {
            this.AccountStore.methods.setUpdatePoint(point);
        },
        setUpdateProfile: function (profile) {
            this.AccountStore.methods.setProfile(profile);
        },
    },
}
